export default "__VITE_ASSET__DVPnWz$h__"